// extracted by mini-css-extract-plugin
export var settingsList = "_3c-0";
export var settingsRow = "_3c-1";
export var warningDot = "_3c-2";